// extracted by mini-css-extract-plugin
export var chevronIcon = "_8u-2";
export var teamName = "_8u-1";
export var teamSwitcherButton = "_8u-0";